<template>
	<component :is="layout">
		<router-view />
	</component>
</template>
<script>
import LayoutVertical from '@/layout/orientation/LayoutVertical.vue'
import LayoutFull from '@/layout/orientation/LayoutFull.vue'

export default {
	name: 'App',
	components: {
		LayoutVertical,
		LayoutFull,
	},
	computed: {
		layout() {
			if (this.$route.meta.layout === 'vertical') return 'layout-vertical'
			return `layout-full`
		},
	},
}
</script>
